export default "__VITE_ASSET__d082d013__"